import React from 'react';
import { Search } from 'lucide-react';
import EmptyState from '../../../../components/not-result';

const LoadSearch = ({
  searchQuery,
  onSearchChange,
  isSearching,
  searchResults,
  showNotFound,
  expandedItem,
  paymentType,
  onSelectLoad,
  highlightMatch
}) => {
  return (
    <>
      <div className="payment-wizard__search-container">
        <Search className="payment-wizard__search-icon" />
        <input
          type="text"
          placeholder="Search by Load ID, Order ID, or VIN..."
          value={searchQuery}
          onChange={onSearchChange}
          className="payment-wizard__search-input form-control"
        />
        {isSearching && <span className="payment-wizard__searching">Searching...</span>}
      </div>

      {!expandedItem && searchQuery && searchResults.length > 0 && (
        <div className="payment-wizard__results-container">
          {searchResults.map((load) => (
            <div key={load._id || load.id} className="payment-wizard__result-wrapper">
              <div
                className="payment-wizard__result-item"
                onClick={() => onSelectLoad(load)}
              >
                <div className="payment-wizard__result-content">
                  <div className="payment-wizard__result-main">
                    <span className="payment-wizard__result-text">
                      {highlightMatch(load.orderId || load._id, searchQuery)}
                    </span>
                    {load.vehicle?.shipment?.[0]?.vin && (
                      <span className="payment-wizard__result-vin">
                        VIN: {highlightMatch(load.vehicle.shipment[0].vin, searchQuery)}
                      </span>
                    )}
                  </div>
                  <div className="payment-wizard__result-details">
                    {paymentType === 'receivable' ? (
                      <>
                        <span>Customer: {load.customer?.companyName || '--'}</span>
                        <span>Rate: ${load.customerRate || '0'}</span>
                      </>
                    ) : (
                      <>
                        <span>Carrier: {load.carrier?.companyName || load.carrier?.name || '--'}</span>
                        <span>Rate: ${load.carrierRate || '0'}</span>
                      </>
                    )}
                    <span className={`payment-wizard__status status-${load.status?.toLowerCase()}`}>
                      {load.status || 'Unknown'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!expandedItem && searchQuery && searchResults.length === 0 && showNotFound && !isSearching && (
        <EmptyState 
          variant="search"
          title="No Loads Found"
          message={`No results for "${searchQuery}"`}
          size="small"
        />
      )}
    </>
  );
};

export default LoadSearch;

